import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { useGoogleLogin } from '@react-oauth/google';
import { useState, useEffect } from 'react';

const PRIMARY = "#2D5BFF";
const PRIMARY_DARK = "#1B3DBF";

// ─── Buddy Mascot ────────────────────────────────────────────────────────────
const BUDDY_HI_IMG = "data:image/webp;base64,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";
const BuddyMascot = ({ size = 100 }) => (
  <img
    src={BUDDY_HI_IMG}
    alt="My Buddy mascot"
    width={size}
    height={size}
    style={{
      width: size,
      height: size,
      objectFit: "contain",
      filter: "drop-shadow(0 8px 24px rgba(45,91,255,0.25))",
    }}
  />
);

// ─── Icons ────────────────────────────────────────────────────────────────────
const IconLock = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="11" width="18" height="11" rx="2" stroke={PRIMARY} strokeWidth="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" stroke={PRIMARY} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconGoogle = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" fill="none">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const IconShield = ({ check = false }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"
      stroke={PRIMARY} strokeWidth="2" strokeLinejoin="round" />
    {check && <path d="M9 12l2 2 4-4" stroke={PRIMARY} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />}
  </svg>
);

const IconGear = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="3" stroke={PRIMARY} strokeWidth="2" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"
      stroke={PRIMARY} strokeWidth="2" />
  </svg>
);

const IconHeart = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
      stroke={PRIMARY} strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

const IconPerson = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="4" stroke={PRIMARY} strokeWidth="2" />
    <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke={PRIMARY} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke="#9CA3AF" strokeWidth="2" />
    <path d="M16 2v4M8 2v4M3 10h18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconClose = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
    <path d="M1 1l12 12M13 1L1 13" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// ─── Terms & Privacy Modal ────────────────────────────────────────────────────
const TERMS_SECTIONS = [
  {
    icon: <IconLock />,
    title: "Your Privacy Matters",
    text: "Your data stays private and secure. We never sell or share your personal data. Only you can access your uploaded receipts and information.",
  },
  {
    icon: <IconGoogle />,
    title: "Google Sign-In",
    text: "We use Google Sign-In for secure authentication. We only access your basic profile information — name, email, and profile photo.",
  },
  {
    icon: <IconShield />,
    title: "Responsible Usage",
    text: "Please avoid uploading payment card details, passwords, banking information, or sensitive personal documents. My Buddy is designed for receipts and purchase-related information only. You are responsible for reviewing the information you upload.",
  },
  {
    icon: <IconShield check />,
    title: "Safe & Respectful Use",
    text: "Please use My Buddy responsibly. Do not upload illegal, harmful, or inappropriate content.",
  },
  {
    icon: <IconGear />,
    title: "Service Updates",
    text: "We may improve or update My Buddy from time to time to enhance your experience. We'll always keep things simple and transparent.",
  },
  {
    icon: <IconHeart />,
    title: "Our Commitment",
    text: "We built My Buddy to help you stay organised with confidence. If you ever have a concern, we're here to help.",
  },
  {
    icon: <IconPerson />,
    title: "Your Rights & Contact",
    text: "You can manage or delete your account at any time directly from your Profile settings. For any other questions, reach us at team@webuilthere.com or visit webuilthere.com.",
  },
];

const TermsModal = ({ onClose, isDesktop }) => (
  <>
    {/* Backdrop */}
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 100,
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
      }}
    />

    {/* Panel */}
    <div
      style={{
        position: "fixed",
        zIndex: 101,
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        ...(isDesktop
          ? {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "min(720px, 90vw)",
              maxHeight: "85vh",
              borderRadius: 20,
              boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
            }
          : {
              bottom: 0,
              left: 0,
              right: 0,
              borderRadius: "24px 24px 0 0",
              maxHeight: "88vh",
              boxShadow: "0 -8px 40px rgba(0,0,0,0.16)",
            }),
      }}
    >
      {/* Drag pill — mobile only */}
      {!isDesktop && (
        <div style={{ display: "flex", justifyContent: "center", paddingTop: 12 }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, backgroundColor: "#E5E7EB" }} />
        </div>
      )}

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          padding: isDesktop ? "28px 32px 20px" : "20px 24px 16px",
          borderBottom: "1px solid #F3F4F6",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            backgroundColor: "#EEF2FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"
              fill="#2D5BFF" fillOpacity="0.15"
              stroke="#2D5BFF" strokeWidth="2" strokeLinejoin="round"
            />
            <path d="M9 12l2 2 4-4" stroke="#2D5BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div style={{ flex: 1 }}>
          <h2 style={{
            fontSize: 17, fontWeight: 700, color: "#1B2B5E",
            fontFamily: "Manrope, sans-serif", margin: 0,
          }}>
            Terms & Privacy
          </h2>
          <p style={{
            fontSize: 13, color: "#9CA3AF",
            fontFamily: "DM Sans, sans-serif", margin: 0,
          }}>
            Simple, transparent, and built for trust.
          </p>
        </div>

        <button
          onClick={onClose}
          style={{
            width: 32, height: 32, borderRadius: 8,
            border: "none", backgroundColor: "#F3F4F6",
            cursor: "pointer", display: "flex",
            alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <IconClose />
        </button>
      </div>

      {/* Scrollable sections */}
      <div
        style={{
          overflowY: "auto",
          flex: 1,
          padding: isDesktop ? "24px 32px" : "20px 24px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
            gap: isDesktop ? "14px 20px" : 12,
          }}
        >
          {TERMS_SECTIONS.map((s, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                gap: 12,
                padding: "14px 16px",
                backgroundColor: "#F9FAFB",
                borderRadius: 14,
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  width: 34, height: 34, borderRadius: 10,
                  backgroundColor: "#EEF2FF",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {s.icon}
              </div>
              <div>
                <p style={{
                  fontSize: 13, fontWeight: 700, color: "#1B2B5E",
                  fontFamily: "Manrope, sans-serif", margin: "0 0 4px",
                }}>
                  {s.title}
                </p>
                <p style={{
                  fontSize: 12, color: "#6B7280",
                  fontFamily: "DM Sans, sans-serif", margin: 0, lineHeight: 1.65,
                }}>
                  {s.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          borderTop: "1px solid #F3F4F6",
          padding: isDesktop ? "18px 32px" : "14px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <IconCalendar />
          <span style={{ fontSize: 12, color: "#9CA3AF", fontFamily: "DM Sans, sans-serif" }}>
            Last updated: May 2026
          </span>
        </div>

        <button
          onClick={onClose}
          style={{
            backgroundColor: PRIMARY, color: "#FFFFFF",
            border: "none", borderRadius: 12,
            padding: "10px 28px",
            fontSize: 14, fontWeight: 600,
            fontFamily: "DM Sans, sans-serif",
            cursor: "pointer",
          }}
        >
          Got it
        </button>
      </div>
    </div>
  </>
);

// ─── Login Page ───────────────────────────────────────────────────────────────
export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const [showTerms, setShowTerms] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => login(tokenResponse.access_token),
    onError: () => console.error('Login Failed'),
  });

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  // ── Shared white card content ──
  const CardContent = () => (
    <>
      {/* Wave + Welcome */}
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <span style={{ fontSize: 30, display: "block", marginBottom: 10 }}>👋</span>
        <h2 style={{
          fontSize: 20, fontWeight: 700, color: "#1B2B5E",
          fontFamily: "Manrope, sans-serif", marginBottom: 4,
        }}>
          Welcome
        </h2>
        <p style={{ fontSize: 14, color: "#9CA3AF", fontFamily: "DM Sans, sans-serif" }}>
          Sign in to get started
        </p>
      </div>

      {/* Google Login Button */}
      <Button
        onClick={handleGoogleLogin}
        disabled={loading}
        className="w-full h-14 rounded-2xl text-base font-medium transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-3"
        style={{
          backgroundColor: "#FFFFFF",
          color: "#333333",
          fontFamily: "DM Sans, sans-serif",
          fontWeight: 600,
          border: "1.5px solid #E0E0E0",
          boxShadow: "none",
        }}
        data-testid="google-login-btn"
      >
        {loading ? (
          <>
            <div className="w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
            Signing in...
          </>
        ) : (
          <>
            <svg width="20" height="20" viewBox="0 0 48 48" fill="none">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            </svg>
            Continue with Google
          </>
        )}
      </Button>

      {/* Trust bullets */}
      <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
        {[
          "Your data stays private and secure.",
          "We never sell or share your personal data.",
        ].map((text, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="#EEF2FF" />
              <path d="M8 12l3 3 5-5" stroke={PRIMARY} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: 12, color: "#6B7280", fontFamily: "DM Sans, sans-serif" }}>
              {text}
            </span>
          </div>
        ))}
      </div>

      {/* Terms link */}
      <p
        style={{
          textAlign: "center",
          marginTop: 20,
          color: "#A1A1AA",
          fontSize: 12,
          fontFamily: "DM Sans, sans-serif",
        }}
      >
        By continuing, you agree to our{" "}
        <button
          onClick={() => setShowTerms(true)}
          style={{
            color: PRIMARY,
            fontWeight: 600,
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            fontSize: 12,
            fontFamily: "DM Sans, sans-serif",
            textDecoration: "underline",
            textUnderlineOffset: 2,
          }}
        >
          Terms & Privacy Policy
        </button>
      </p>

      {/* Spacer */}
      <div style={{ flex: 1, minHeight: 28 }} />

      {/* We Built Here attribution */}
      <div
        style={{
          borderTop: "1px solid #F3F4F6",
          paddingTop: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", gap: 3 }}>
          <span style={{ fontSize: 12, color: "#A1A1AA", fontFamily: "DM Sans, sans-serif" }}>
            by{" "}
            <span style={{ color: "#6B7280", fontWeight: 600 }}>We Built Here</span>
          </span>
          <div style={{ width: 24, height: 2.5, borderRadius: 2, backgroundColor: "#4F46E5" }} />
        </div>
      </div>
    </>
  );

  // ── Render ──
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: "#F0F4FF" }}
      data-testid="login-page"
    >
      <style>{`
        .login-hero-dots {
          position: absolute; inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.12) 1px, transparent 1px);
          background-size: 24px 24px;
          pointer-events: none;
        }
      `}</style>

      {/* Terms modal */}
      {showTerms && <TermsModal onClose={() => setShowTerms(false)} isDesktop={isDesktop} />}

      {/* ── Hero — same for mobile and web ── */}
      <div
        className="relative flex flex-col items-center justify-center"
        style={{
          background: `linear-gradient(160deg, #4A7AFF 0%, ${PRIMARY} 40%, ${PRIMARY_DARK} 100%)`,
          padding: isDesktop ? "72px 24px 60px" : "56px 24px 48px",
          textAlign: "center",
        }}
      >
        <div className="login-hero-dots" />
        <div style={{ position: "relative", zIndex: 1, marginBottom: 16 }}>
          <BuddyMascot size={isDesktop ? 120 : 100} />
        </div>
        <h1 style={{
          position: "relative", zIndex: 1,
          color: "#FFFFFF",
          fontSize: isDesktop ? 34 : 28,
          fontWeight: 700,
          fontFamily: "Manrope, sans-serif",
          marginBottom: 6,
        }}>
          My Buddy
        </h1>
        <p style={{
          position: "relative", zIndex: 1,
          color: "rgba(255,255,255,0.75)",
          fontSize: isDesktop ? 16 : 14,
          fontFamily: "DM Sans, sans-serif",
          lineHeight: 1.5,
        }}>
          Keeping track, so you don't have to.
        </p>
      </div>

      {/* ── White card — full-width mobile, centred+constrained on desktop ── */}
      <div
        className="flex-1 flex flex-col"
        style={{
          marginTop: -24,
          position: "relative",
          zIndex: 2,
          ...(isDesktop && {
            alignItems: "center",
            paddingBottom: 40,
          }),
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: isDesktop ? 24 : "24px 24px 0 0",
            padding: isDesktop ? "40px 40px 36px" : "36px 28px 32px",
            boxShadow: isDesktop
              ? "0 -4px 30px rgba(0,0,0,0.06), 0 24px 60px rgba(0,0,0,0.10)"
              : "0 -4px 30px rgba(0,0,0,0.06)",
            flex: isDesktop ? undefined : 1,
            display: "flex",
            flexDirection: "column",
            ...(isDesktop && {
              width: "100%",
              maxWidth: 480,
            }),
          }}
        >
          <CardContent />
        </div>
      </div>
    </div>
  );
}